import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
export const contentFeatureHeights = {
    SMALL: '400px',
    MEDIUM: '512px',
    LARGE: '804px',
};
const useStyles = makeStyles()((theme, _params, classes) => ({
    container: {
        // For full width image to position against
        position: 'relative',
        display: 'flex',
        // Mobile - image below content
        flexDirection: 'column-reverse',
        placeContent: 'center',
        overflow: 'hidden',
        '& video': {
            display: 'block',
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
            objectFit: 'cover',
        },
    },
    heading: {
        'h1&,h2&,h3&,h4&,div&': Object.assign(Object.assign({}, theme.typography.medium_bold), { marginBottom: _params.isQuotation ? 0 : spacing.small, [theme.breakpoints.up('xl')]: Object.assign({}, theme.typography.xl_bold) }),
    },
    message: {
        'p&,div&': Object.assign(Object.assign(Object.assign({}, theme.typography.small_regular), theme.typographySpacing.small_regular_sm), { [theme.breakpoints.up('md')]: Object.assign({}, theme.typographySpacing.small_regular_lg) }),
    },
    contentInner: {
        'h1&,h2&,h3&,h4&,div&,p&': {
            padding: spacing.large,
            margin: 'initial',
            [theme.breakpoints.up('sm')]: {
                padding: spacing.large,
            },
            [theme.breakpoints.up('md')]: {
                padding: `${spacing.large} ${spacing.xl}`,
            },
            [theme.breakpoints.up('lg')]: {
                padding: spacing.xl,
            },
            [theme.breakpoints.up('xl')]: {
                padding: spacing.xxl,
            },
        },
        '& > :last-child': {
            marginBottom: spacing.large,
            [theme.breakpoints.up('md')]: {
                marginBottom: '0px',
            },
        },
    },
    headingLine: {
        alignSelf: 'flex-start',
        marginBottom: spacing.xs,
        display: 'block',
    },
    positionBottom: {
        justifyContent: 'flex-start',
        alignItems: 'flex-end',
    },
    positionTop: {
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
    },
    positionCenter: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    largeAdvertisingHeading: Object.assign(Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.large_bold_sm), { [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.xxl_bold), theme.typographySpacing.xxl_bold_sm), [theme.breakpoints.up('xl')]: Object.assign(Object.assign({}, theme.typography.xxxxl), theme.typographySpacing.xxxxl_sm) }),
    standardHeading: Object.assign(Object.assign(Object.assign({}, theme.typography.medium_bold), theme.typographySpacing.medium_bold_sm), { [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.large_bold_sm), [theme.breakpoints.up('xl')]: Object.assign(Object.assign({}, theme.typography.xl_bold), theme.typographySpacing.xl_bold_sm) }),
    quotationTitle: {
        marginBottom: `0 !important`, // important to override the default margin
        paddingBottom: `2px !important`, // important to override the default padding
        ' > span': {
            marginBottom: 0,
        },
    },
    headingColor: {
        color: (_params === null || _params === void 0 ? void 0 : _params.headingColor) ? `${colors.genericContentHeading[_params === null || _params === void 0 ? void 0 : _params.headingColor]}` : '',
    },
    ffImage: {},
    positionLeft: {
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row-reverse',
        },
    },
    positionRight: {
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
        },
    },
    minHeightSmall: {
        [theme.breakpoints.up('sm')]: {
            height: contentFeatureHeights.SMALL,
        },
        '& button': {
            '& img': {
                [theme.breakpoints.up('sm')]: {
                    height: `${contentFeatureHeights.SMALL} !important`, //important to override the inline styles for img tag
                    objectFit: 'cover',
                },
            },
        },
    },
    minHeightMedium: {
        [theme.breakpoints.up('sm')]: {
            height: contentFeatureHeights.MEDIUM,
        },
        '& button': {
            '& img': {
                [theme.breakpoints.up('sm')]: {
                    height: `${contentFeatureHeights.MEDIUM} !important`, // important to override the inline styles for img tag
                    objectFit: 'cover',
                },
            },
        },
    },
    minHeightLarge: {
        [theme.breakpoints.up('sm')]: {
            height: contentFeatureHeights.LARGE,
        },
        '& button': {
            '& img': {
                [theme.breakpoints.up('sm')]: {
                    height: `${contentFeatureHeights.LARGE} !important`, // important to override the inline styles for img tag
                    objectFit: 'cover',
                },
            },
        },
    },
    thirdLink: {
        gridColumn: '1 / 3', // span across both columns
        justifySelf: 'center',
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '50%',
        },
    },
    linkItem: {
        [theme.breakpoints.down('md')]: {
            paddingLeft: '0',
            width: '100%',
        },
        '& button': {
            height: '100%',
        },
    },
    linkGrid: {
        [theme.breakpoints.down('md')]: {
            width: '100%',
            flexDirection: 'column',
        },
    },
    textLeft: {
        [theme.breakpoints.up('md')]: {
            justifyContent: 'left',
        },
    },
    textRight: {
        [theme.breakpoints.up('md')]: {
            justifyContent: 'right',
            marginLeft: `-${spacing.small}`,
        },
    },
    textCenter: {
        [theme.breakpoints.up('md')]: {
            justifyContent: 'center',
        },
    },
    link: {
        '& button .labelSmall': {
            padding: 0,
        },
    },
    quotationMessage: {
        marginBottom: `${spacing.medium} !important`, // important to override the default margin
    },
    content: {},
    image: {},
}));
export default useStyles;
